import type {TMillions} from '../../types/millions'

export const show$ = (millions: TMillions) => `$${millions}M`
